export default (result) => {
  const runsDetail = result.details.find((detail) => detail.name === 'Runs');
  if (!runsDetail) return [];

  return runsDetail.details.map((run) => {
    return {
      value: run.values[1],
      isHighlighted: typeof run.values[2] === 'string' && run.values[2].trim().toLowerCase() === 'true',
      isCurrent: typeof run.values[4] === 'string' && run.values[4].trim().toLowerCase() === 'true',
      isDrop: typeof run.values[5] === 'string' && run.values[5].trim().toLowerCase() === 'true',
    };
  });
};



// WEBPACK FOOTER //
// ./src/utils/parseResultIntoRuns.js